adminRole
<div ng-controller="userRoleController as userRoleCtrl" class="modal-view">
    <c-auto-form config="userRoleCtrl.autoFormConfig"></c-auto-form>
</div>